<template>
  <div>
    <!-- <pre class="s">

{{ breadcrumb }}
</pre
    > -->
    <v-breadcrumbs class="ui-breadcrumb" v-if="breadcrumb && breadcrumb.length">
      <template v-for="(crumb, index) in truncatedBreadcrumb" :key="index">
        <v-breadcrumbs-item v-if="!crumb.isEllipsis" @click="goToBreadcrumb(crumb, index)"
          :disabled="index === truncatedBreadcrumb.length - 1">
          <span>{{ crumb.name || "..." }}</span>
          <ui-icon name="chevron-right" :size="14" v-if="index < truncatedBreadcrumb.length - 1" />
        </v-breadcrumbs-item>

        <v-breadcrumbs-item v-else disabled>
          <span>...</span>
          <ui-icon name="chevron-right" :size="14" />
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/appStore";

export default {
  name: "BreadcrumbWidget",

  data() {
    return {
      appStore: useAppStore(),
    };
  },

  computed: {
    breadcrumb() {
      return this.appStore.breadcrumb || [];
    },
    pages() {
      return this.appStore.pages || [];
    },
    activePage() {
      return this.appStore.active.page || {};
    },
    truncatedBreadcrumb() {
      const bc = this.breadcrumb;
      if (!Array.isArray(bc) || bc.length === 0) return [];

      if (bc.length <= 5) return bc;

      const first = bc[0];
      const last = bc[bc.length - 1];
      const secondLast = bc[bc.length - 2];

      return [first, { isEllipsis: true }, secondLast, last];
    },
  },

  methods: {
    goToBreadcrumb(crumb, index) {
      if (!crumb || crumb.isEllipsis) return;

      this.appStore.breadcrumb = this.breadcrumb.slice(0, index + 1);

      const targetPage = this.pages.find((p) => p.id === crumb.id);
      if (targetPage) {
        this.appStore.setActivePage(targetPage);
        this.appStore.setActiveView(targetPage);
      }

      if (crumb.item) {
        this.appStore.setSelectedItem(crumb.item);
      }
    },
  },
};
</script>
